import { render, staticRenderFns } from "./ApexClubPitch.vue?vue&type=template&id=6798f774"
import script from "./ApexClubPitch.vue?vue&type=script&lang=js"
export * from "./ApexClubPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports